export default __webpack_public_path__ + "static/media/icon-bell.9183e190.svg";